import styled, { css } from 'styled-components';
import { borderRadius, paddings } from '~/styled';

const borderColors = {
  error: 'rgba(220, 40, 50, 0.35)',
  warning: 'rgba(255, 200, 0,0.35)',
  info: 'rgba(7, 175, 220, 0.35)',
};

const bgOnSurfaceWhite = {
  error: 'rgba(220, 40, 50, 0.10)',
  warning: 'rgba(255, 200, 0,0.10)',
  info: 'rgba(7, 175, 220, 0.10)',
};

export const ModalMessage = styled.div<{
  $position: 'top' | 'bottom';
  $type: 'error' | 'warning' | 'info';
  $customStyled?: ReturnType<typeof css>;
}>`
  display: flex;
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: ${borderRadius.default};
  padding: ${paddings.mediumPadding};
  width: 100%;
  align-items: center;
  ${({ $position, $type }) => {
    if ($position === 'bottom') {
      return css`
        width: auto;
        min-width: 350px;
        width: calc(85% - 12px);
        max-width: 650px;
        margin: 0;
        padding-right: ${paddings.mediumPadding};
        border: 1px solid ${borderColors[$type]};
        border-radius: ${borderRadius.small};
        height: 48px;
        padding-top: ${paddings.tinyPadding};
        padding-bottom: ${paddings.smallPadding};
        ${MessageIcon} {
          width: 25px;
          padding-top: ${paddings.tinyPadding};
        }
      `;
    }

    if ($position === 'top') {
      return css`
        position: relative;
        top: 0;
        left: 0;
        margin: 0;
        padding-right: ${paddings.defaultPadding};
        border: none;
        container-type: block;
        background-color: ${bgOnSurfaceWhite[$type]};
        border-radius: 0;
      `;
    }
  }}
  ${({ $customStyled }) =>
    $customStyled &&
    css`
      ${$customStyled}
    `};
`;

export const MessageIcon = styled.div`
  width: 50px;
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: center;
  overflow-x: hidden;
`;

export const MessageContent = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  padding-left: ${paddings.mediumPadding};
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;

export const MessageTitle = styled.h4`
  width: 100%;
  margin-bottom: ${paddings.smallPadding};
  font-weight: 600;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.onBackground};
`;

export const MessageText = styled.p`
  width: 100%;
  margin-bottom: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.onBackground};
  margin: 0;
  line-height: 1.25;
`;

export const CloseIcon = styled.button`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.red500};
  width: 35px;
  height: 100%;
  border-radius: 8px;
  border: none;
  background-color: transparent;
  justify-content: center;
  display: flex;
  align-items: center;
  padding: 0;
  cursor: pointer;
`;

export const CloseButtonDiv = styled.div<{ $isInMobileDevice?: boolean }>`
  width: 35px;
  height: 100;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${({ $isInMobileDevice }) =>
    !$isInMobileDevice &&
    css`
      display: none;
    `}
`;
